module.exports = __webpack_public_path__ + "static/media/leaderboard-img4.126b6c5b.jpeg";